export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_FE-ja-JP.d559e117.xlsx";